var _defs, _path, _path2, _path3, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrbieeMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-20.35 -221 202.69 225.7",
    role: "img",
    "aria-label": "Orbiee mark \\u2014 Orbit",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Orbiee mark \u2014 Orbit") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "orbit-mark-light",
    maskUnits: "userSpaceOnUse",
    x: -10000,
    y: -10000,
    width: 20000,
    height: 20000
  }, /*#__PURE__*/React.createElement("rect", {
    x: -10000,
    y: -10000,
    width: 20000,
    height: 20000,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81 2.7Q66.6 2.7 54 -5.85Q41.4 -14.4 31.95 -29.4Q22.5 -44.4 17.25 -64.65Q12 -84.9 12 -108.3Q12 -131.7 17.25 -151.8Q22.5 -171.9 31.95 -187.05Q41.4 -202.2 54 -210.6Q66.6 -219 81 -219Q95.4 -219 107.85 -210.6Q120.3 -202.2 129.9 -187.05Q139.5 -171.9 144.75 -151.8Q150 -131.7 150 -108.3Q150 -84.9 144.75 -64.65Q139.5 -44.4 129.9 -29.4Q120.3 -14.4 107.85 -5.85Q95.4 2.7 81 2.7ZM81 -5.4Q102.3 -5.4 114.3 -30.9Q126.3 -56.4 126.3 -108.3Q126.3 -160.2 114.3 -185.55Q102.3 -210.9 81 -210.9Q60 -210.9 47.85 -185.55Q35.7 -160.2 35.7 -108.3Q35.7 -56.4 47.85 -30.9Q60 -5.4 81 -5.4Z",
    fill: "#000",
    stroke: "#000",
    strokeWidth: 17.28,
    strokeLinejoin: "round"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-21.12 -108.15 A102.12 55.42 0 0 1 183.12 -108.15",
    transform: "rotate(-16 81 -108.15)",
    fill: "none",
    stroke: "#15140f",
    strokeWidth: 5.4,
    mask: "url(#orbit-mark-light)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81 2.7Q66.6 2.7 54 -5.85Q41.4 -14.4 31.95 -29.4Q22.5 -44.4 17.25 -64.65Q12 -84.9 12 -108.3Q12 -131.7 17.25 -151.8Q22.5 -171.9 31.95 -187.05Q41.4 -202.2 54 -210.6Q66.6 -219 81 -219Q95.4 -219 107.85 -210.6Q120.3 -202.2 129.9 -187.05Q139.5 -171.9 144.75 -151.8Q150 -131.7 150 -108.3Q150 -84.9 144.75 -64.65Q139.5 -44.4 129.9 -29.4Q120.3 -14.4 107.85 -5.85Q95.4 2.7 81 2.7ZM81 -5.4Q102.3 -5.4 114.3 -30.9Q126.3 -56.4 126.3 -108.3Q126.3 -160.2 114.3 -185.55Q102.3 -210.9 81 -210.9Q60 -210.9 47.85 -185.55Q35.7 -160.2 35.7 -108.3Q35.7 -56.4 47.85 -30.9Q60 -5.4 81 -5.4Z",
    fill: "#15140f"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M183.12 -108.15 A102.12 55.42 0 0 1 -21.12 -108.15",
    transform: "rotate(-16 81 -108.15)",
    fill: "none",
    stroke: "#15140f",
    strokeWidth: 5.4
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 148.95,
    cy: -163.13,
    r: 13.5,
    fill: "#7d5a37"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrbieeMark);
export default __webpack_public_path__ + "static/media/orbiee-mark.4a38db982d7a8be99dce592fdab82874.svg";
export { ForwardRef as ReactComponent };